var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow53(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1188_25765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9597 19.8595C43.9597 17.8401 42.3101 16.2031 40.2753 16.2031C38.4173 16.2031 36.8814 17.5682 36.6283 19.3427L36.591 19.3232C33.5779 17.9745 31.0398 20.3633 31.0398 20.3633L24.3262 27.0586L26.9789 29.5937L32.3826 24.3252C34.9059 21.8209 36.2799 23.5159 36.2799 23.5159C38.1795 25.1084 36.3453 26.9935 36.3453 26.9935L39.0636 29.5937C41.2834 27.2145 41.4121 25.1381 40.7373 23.4863C42.554 23.2605 43.9597 21.7235 43.9597 19.8595Z",
    fill: "#F9AE41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7709 36.6757C40.7835 36.6523 40.7906 36.6388 40.7906 36.6388C42.1497 33.6484 39.7425 31.1296 39.7425 31.1296L32.9959 24.4668L30.4414 27.0996L35.7503 32.4621C38.2736 34.9664 36.5657 36.33 36.5657 36.33C34.9611 38.2151 33.0615 36.3949 33.0615 36.3949L30.4414 39.0925C32.8388 41.2953 34.9312 41.4231 36.5955 40.7535C36.823 42.5563 38.372 43.9514 40.2502 43.9514C42.285 43.9514 43.9345 42.3144 43.9345 40.295C43.9345 38.4512 42.5591 36.9269 40.7709 36.6757Z",
    fill: "#EE4035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0535 30.4375L27.6498 35.706C25.1264 38.2103 23.7524 36.5155 23.7524 36.5155C21.8529 34.9228 23.6869 33.0378 23.6869 33.0378L20.9688 30.4375C18.7491 32.8166 18.6202 34.8931 19.2949 36.5449C17.4782 36.7707 16.0725 38.3077 16.0725 40.1717C16.0725 42.1911 17.7221 43.828 19.757 43.828C21.615 43.8281 23.1509 42.4632 23.404 40.6886C23.4276 40.7011 23.4413 40.7081 23.4413 40.7081C26.4545 42.0571 28.9925 39.6679 28.9925 39.6679L35.7063 32.9726L33.0535 30.4375Z",
    fill: "#4F91CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2819 27.5714C21.7585 25.0671 23.4662 23.7035 23.4662 23.7035C25.0712 21.8183 26.9706 23.6386 26.9706 23.6386L29.5907 20.9411C27.1934 18.7382 25.101 18.6105 23.4366 19.28C23.2091 17.477 21.6604 16.082 19.7818 16.082C17.7473 16.082 16.0979 17.7191 16.0977 19.7384C16.0977 21.5824 17.4731 23.1067 19.2613 23.3578C19.2487 23.3812 19.2417 23.3949 19.2417 23.3949C17.8824 26.3851 20.2897 28.9038 20.2897 28.9038L27.0364 35.5666L29.5909 32.934L24.2819 27.5714Z",
    fill: "#7AC043"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_25765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow53);
export default __webpack_public_path__ + "static/media/row-5-3.87e6b5b2c83fc28edafc0d94c8453818.svg";
export { ForwardRef as ReactComponent };